module.exports = __webpack_public_path__ + "static/img/site.135cf6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/site.jpg
// module id = xeok
// module chunks = 1